import { Component, OnInit, Input, ViewChild, Output,EventEmitter,AfterViewInit } from '@angular/core';
 
import { _HttpClient } from '../../net/http.client';
import { ApiService } from '../../net/apiRoute';
import { NzTreeComponent, NzTreeNode, NzTreeNodeOptions } from 'ng-zorro-antd/tree';

@Component({
  selector: 'app-tree-menus',
  templateUrl: './app-tree-menus.component.html',
  styleUrls: ['./app-tree-menus.component.css']
})

export class AppTreeMenusComponent implements OnInit,AfterViewInit  {
@ViewChild('nzTreeComponent', { static: false }) nzTreeComponent!: NzTreeComponent;

  nodes:NzTreeNodeOptions[] = []; // tree 数据源
  nzCheckStrictly = false;
  defaultCheckedKeys = []; // 默认选中项
  defaultSelectedKeys = [];
  defaultExpandedKeys = [];
  selectNodes = []; // 选中节点ID集合

  @Input() roleId:any;
  @Output() checkdEvent:any = new EventEmitter();

  constructor(public http:_HttpClient) {

  }

  ngOnInit(): void {
 
    this.loadData(this.roleId);
  }

  // checkbox 选择事件
  nzCheck(event): void {
 
      var treeNodes = this.nzTreeComponent.getTreeNodes();
      this.getCheckdNodes(treeNodes);
      this.checkdEvent.emit(this.selectNodes);
 
  }

  // 获取选中nodes
  getCheckdNodes(nodes: NzTreeNode[]):void
  {
    this.selectNodes= [];
    let keyData = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!node.isLeaf && (node.isHalfChecked || node.isChecked)) {
       this.selectNodes.push(node.key);
        var nodeChildlength = node.children.length;
        for (var j = 0; j < nodeChildlength; j++) {
          if (node.children[j].isChecked) {
            this.selectNodes.push(node.children[j].key);
          }
        }
      }
    }
  }


  nzSelect(event): void {

  }


  ngAfterViewInit(): void {
    var treeNodes = this.nzTreeComponent.getTreeNodes();
    this.getCheckdNodes(treeNodes);
    console.log(
      this.nzTreeComponent.getTreeNodes(),
      this.nzTreeComponent.getCheckedNodeList(),
      this.nzTreeComponent.getSelectedNodeList(),
      this.nzTreeComponent.getExpandedNodeList()
    );
  }


    // 加载数据
  loadData(roleId) {
    this.http.get(ApiService.GetSelectMenuTree, { roleId: roleId}).subscribe((res: any) => {
      this.nodes = res.Result.nodes;
      this.defaultCheckedKeys = res.Result.defaultCheckedKeys.map((x)=>{
          return x.MenuId
      });
      // console.log("defaultCheckedKeys:"+this.defaultCheckedKeys);
    });
  }
}
